'use strict';Object.defineProperty(exports,"__esModule",{value:true});exports.getVersionString=getVersionString;var VERSION='3.0.3';function getVersionString(){return VERSION;}
//# sourceMappingURL=Version.js.map
